module.exports = __webpack_public_path__ + "img/test_r8.7f57e1c3.png";